import { render, staticRenderFns } from "./SoftwareRegistration.vue?vue&type=template&id=09207435&scoped=true"
import script from "./SoftwareRegistration.vue?vue&type=script&lang=js"
export * from "./SoftwareRegistration.vue?vue&type=script&lang=js"
import style0 from "./SoftwareRegistration.vue?vue&type=style&index=0&id=09207435&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09207435",
  null
  
)

export default component.exports